import { useState } from 'react'
import { Button, TextField } from '@krp/ui-kit'
import { codeProblem } from '../model/profile'

export interface OwnCashierCodeCardProps {
  hasCode: boolean
  codeMinLength: number
  codeMaxLength: number
  canManage: boolean
  busy: boolean
  /** Задать код; код в состояние приложения не попадает и стирается из поля после отправки. */
  submit: (code: string) => Promise<boolean>
}

/** Код входа кассира в РМК: задаётся один раз, одним полем, без повтора. Сам код нигде не показывается. */
export function OwnCashierCodeCard(props: OwnCashierCodeCardProps) {
  const [code, setCode] = useState('')
  const problem = codeProblem(code, code, props.codeMinLength, props.codeMaxLength)
  const ready = props.canManage && !props.busy && problem === null
  const send = async () => {
    if (!ready) return
    await props.submit(code)
    setCode('')
  }
  return <section className="own-cashiers__card" aria-label="Код кассира">
    <h3>Код кассира</h3>
    <p role="status">{props.hasCode
      ? '🔒 Код задан. По нему кассир входит в РМК, выбирать себя из списка не нужно. Новый код заменит прежний — кассиру придётся войти в РМК заново.'
      : '⚠ Кода нет: кассир не сможет войти в РМК, пока код не задан.'}</p>
    <fieldset disabled={!props.canManage || props.busy}>
      <TextField label={props.hasCode ? 'Новый код' : 'Код'} type="password" value={code} onChange={setCode} />
      {code !== '' && problem !== null && <p role="status">⚠ {problem}</p>}
      <div className="own-cashiers__actions">
        <Button variant="primary" actionId="receipts.own-cashiers.set-code" busy={props.busy} disabled={!ready}
          disabledReason={props.canManage ? problem : 'Нужно право управления кассирами'} onClick={() => { void send() }}>
          {props.hasCode ? 'Сменить код' : 'Задать код'}</Button>
      </div>
    </fieldset>
  </section>
}
